/* eslint-disable */

/** unique or primary key constraints on table "argo.sn_format_status" */
export enum ArgoSnFormatStatusConstraint {
  /** unique or primary key constraint on columns "value" */
  SnFormatStatusPkey = 'sn_format_status_pkey'
}

export enum ArgoSnFormatStatusEnum {
  /** Activated */
  Activated = 'activated',
  /** Archived */
  Archived = 'archived',
  /** Editing */
  Editing = 'editing'
}

/** select columns of table "argo.sn_format_status" */
export enum ArgoSnFormatStatusSelectColumn {
  /** column name */
  Text = 'text',
  /** column name */
  Value = 'value'
}

/** update columns of table "argo.sn_format_status" */
export enum ArgoSnFormatStatusUpdateColumn {
  /** column name */
  Text = 'text',
  /** column name */
  Value = 'value'
}

